import { useEffect, useRef } from "react";
import CounterNumber from "./CounterNumber";

function RedesignedCaseStudies() {
    const advantages = [
        {
            stat: "90%",
            label: "Decisions Driven by Emotions",
            description: "Traditional content ignores the primary driver of human choice"
        },
        {
            stat: "Time 0",
            label: "Instant Personalization",
            description: "Recommend content without user data or profile history—emotional state is enough"
        },
        {
            stat: "3x",
            label: "Emotional Involvement",
            description: "Users feel deeper connection with content adapted to their emotional state"
        },
        {
            stat: "Real-Time",
            label: "Emotional Correlation",
            description: "Content adapts dynamically based on live emotional state, not static preferences"
        },
        {
            stat: "Peak",
            label: "Moment of Intent",
            description: "Capture users at the emotional peak when decisions are made—not before, not after"
        }
    ];

    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.scroll-animate, .scroll-animate-fade').forEach((el) => {
                            el.classList.add('animate-in');
                        });
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <section ref={sectionRef} className="redesign-case-studies">
            <div className="redesign-case-studies-container">
                <div className="redesign-section-header scroll-animate-fade">
                    <div className="redesign-section-label">WHY IT MATTERS</div>
                    <h2 className="redesign-section-title">The <span style={{color: '#F50000'}}>E</span>motional Advantage</h2>
                    <p className="redesign-section-description">
                        Revolutionary capabilities that transform how content connects with people
                    </p>
                </div>
                <div className="redesign-case-studies-grid" style={{display: 'grid', gap: '2rem'}}>
                    {/* Hero Card - 90% stat - WHITE */}
                    <div className="redesign-case-study-card scroll-animate" style={{gridColumn: '1 / -1', textAlign: 'center'}}>
                        <div className="redesign-result-number case-study-hero-stat">
                            <CounterNumber value="90%" />
                        </div>
                        <h3 className="redesign-case-study-title case-study-hero-title">{advantages[0].label}</h3>
                        <p className="redesign-section-description" style={{maxWidth: '700px', margin: '0 auto'}}>
                            {advantages[0].description}
                        </p>
                    </div>
                    
                    {/* Second row - 2 cards: RED, WHITE */}
                    <div className="case-study-pair" style={{gridColumn: '1 / -1'}}>
                        {advantages.slice(1, 3).map((advantage, index) => (
                            <div key={index + 1} className={`redesign-case-study-card scroll-animate ${index === 0 ? 'red-card' : ''}`}>
                                <div className="redesign-result-number" style={{fontSize: '3.5rem', marginBottom: '1rem', textAlign: 'center'}}>
                                    {advantage.stat === '3x' ? (
                                        <CounterNumber value={advantage.stat} />
                                    ) : (
                                        advantage.stat
                                    )}
                                </div>
                                <h3 className="redesign-case-study-title" style={{textAlign: 'center', marginBottom: '1rem', fontSize: '1.5rem'}}>{advantage.label}</h3>
                                <p className="redesign-section-description" style={{textAlign: 'center', fontSize: '0.95rem'}}>
                                    {advantage.description}
                                </p>
                            </div>
                        ))}
                    </div>
                    
                    {/* Third row - 2 cards: WHITE, RED */}
                    <div className="case-study-pair" style={{gridColumn: '1 / -1'}}>
                        {advantages.slice(3).map((advantage, index) => (
                            <div key={index + 3} className={`redesign-case-study-card scroll-animate ${index === 1 ? 'red-card' : ''}`}>
                                <div className="redesign-result-number" style={{fontSize: '3.5rem', marginBottom: '1rem', textAlign: 'center'}}>
                                    {advantage.stat === '3x' ? (
                                        <CounterNumber value={advantage.stat} />
                                    ) : (
                                        advantage.stat
                                    )}
                                </div>
                                <h3 className="redesign-case-study-title" style={{textAlign: 'center', marginBottom: '1rem', fontSize: '1.5rem'}}>{advantage.label}</h3>
                                <p className="redesign-section-description" style={{textAlign: 'center', fontSize: '0.95rem'}}>
                                    {advantage.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default RedesignedCaseStudies;
